import css from '@/components/ui/shared/Table/cells/DateCell.module.css';
import {
  formatDateTime,
  formatRelativeDate
} from '@/utils/helpers/formatTimeDate';

interface Props {
  date?: string | null;
  format?: 'relative' | 'dateTime';
}

export function DateCell({ date, format = 'relative' }: Props) {
  if (!date) return null;

  const label =
    format === 'relative' ? formatRelativeDate(date) : formatDateTime(date);

  return <span className={css.date}>{label}</span>;
}
